import React from "react"
import { mainHeaderBG, mainHeaderTurtle } from "../../static/svgs/mainHeader"
import Image from "../Image"
import { MainHeaders, MainHeadersData } from "./types/mainHeaders"

type Props = { header: MainHeaders }

const MainHeader = ({ header }: Props) => {
  return (
    <div
      className={`h-screen flex justify-center bg-cover`}
      style={{
        backgroundImage: `url(${mainHeaderBG})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
      }}
    >
      <div className="h-2/3 relative top-1/2 -translate-y-1/2">
        <Image
          label="header-turtle"
          className="h-full"
          url={MainHeadersData[header].turtle}
          style={{
            filter:
              "drop-shadow(-10px -10px 30px rgba(0, 0, 0, 0.25))",
          }}
        />
      </div>
      <span
        className="absolute -translate-y-1/2 font-jost-medium font-semibold text-3xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-[160px] text-center text-white uppercase"
        style={{
          top: "calc(50% + 5rem)",
          textShadow:
            "-10px -10px 30px rgba(0, 0, 0, 0.25), 10px 4px 30px rgba(0, 0, 0, 0.25)",
        }}
      >
        {MainHeadersData[header].pageName}
      </span>
    </div>
  )
}

export default MainHeader
